export enum AppRouteSections {
  FEED,
  EXPLORE,
  PORTFOLIO,
  MY_ACCOUNT,
  MY_TOGGLE,
  CHART,
  ANALYZE,
  SCENARIO,
  SUPPORT,
  POSITIONS,
  GEN_AI,
  CHARTV2,
}

export const SubscriptionUpgradeRouteParams = {
  BASIC_ONLY_5_STAR_ALLOWED: 1,
  BASIC_NO_INSIGHTS_REMAINING: 2,
  BASIC_INSIGHTS_REMAINING: 4,
  COPILOT_CANNOT_VIEW_ASSET: 5,
  COPILOT_INSIGHTS_REMAINING: 6,
  COPILOT_CUSTOM_CONDITIONS: 8,
  BASIC_LIMIT: 9,
  BASIC_NO_SAVE_FILTER: 12,
};

/**
 * @deprecated
 * Please use "apps/webapp/src/routes/app-paths.ts" instead
 */
export const BASE_ROUTE = '/';
export const APP_ROUTE = '/app';
export const MY_TOGGLE_ROUTE = '/my-toggle';
export const PORTFOLIO_ROUTE = '/portfolio';
export const EXPLORE_ROUTE = '/explore';
export const AI_CHAT_ROUTE = `${APP_ROUTE}/ai-chat`;
export const ARTICLE_ROUTE = '/article/';
export const SUBSCRIPTION_UPGRADE_ROUTE = '/upgrade';
export const VERIFY_ROUTE = '/verify-email';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const EMAIL_TO_RESET_PATH = 'emailToReset';
export const ERROR_ROUTE = '/error';
export const NOT_FOUND_ROUTE = '/*';
export const REDIRECT_QUERY_KEY = 'redirectTo';
export const LIMITED_PARAM = 'limited';
export const PROMO_CODE = 'promo_code';
export const ANALYZE_ROUTE = '/analyze';
export const PAYMENT_CONFIRMATION = '/payment-confirmation';

export const MY_ACCOUNT_ROUTES = {
  CHECKOUT_ROUTE: 'checkout',
  STEP_2_BILLING_INFORMATION: 'billing-information',
  SELECT_PLAN_ROUTE: 'plans',
};

export const PUBLIC_WEBSITE_ROUTES = {
  LEARN_CENTER: '/investing',
};

export const SLUGS = {
  FEED_SLUG: 'feedView',
  MY_TOGGLE_SLUG: 'myToggle',
  FEED_BY_AUTHOR_SLUG: 'feedViewByAuthor',
  FEED_BY_TAG_SLUG: 'feedViewByTag',
  EXPLORE_SLUG: 'exploreView',
  OVERVIEW_WIDGET_SLUG: 'overviewWidgetView',
  ONBOARDING_SLUG: 'onboardingView',
  SETTINGS_SLUG: 'settings',
  CHART_SLUG: 'chartView',
  ANALYZE_SLUG: 'analyzeView',
  MYACCOUNT_SLUG: 'myaccountView',
};
export const VIEW_QUERY_KEY = 'view';
